<template>
  <v-card
    class="d-flex justify-center ma-0 my-2"
    :class="[$vuetify.breakpoint.smAndDown ? 'row mx-4' : 'pl-4']"
    flat
  >
    <v-card
      max-width="150"
      class="rectangle col-4"
      v-for="(item, i) in damage"
      :key="i"
      :class="[
        { 'ml-3': i != 0 && $vuetify.breakpoint.mdAndUp },
        { 'col-12 mb-4': $vuetify.breakpoint.smAndDown }
      ]"
    >
      <div pa-0>
        <div class="outline-menu">
          <v-img v-if="item.icon" class="menu" :src="item.icon"></v-img>
          <i
            v-else-if="item.iconfa"
            :class="`fas fa-` + item.iconfa + ` fa-3x`"
            class="ma-0 mt-2"
          ></i>
        </div>
      </div>
      <div class="stat">
        <p class="subtitle-2 mt-3 mb-2">{{ item.name }}</p>
        <p class="font-weight-medium my-0 headline number">{{ item.today | numFormat }}</p>
        <!-- <p class="subtitle-2 mt-3 mb-0"> สะสม </p>
        <p class="title my-0"> {{ item.summary | numFormat }} </p>-->
      </div>
    </v-card>
  </v-card>
</template>

<script>
export default {
  name: 'Today',
  data: () => ({
    damage: []
  }),
  created() {
    this.getInitDamage();
  },
  mounted() {},
  methods: {
    getInitDamage() {
      this.damage = [
        {
          name: 'อุบัติการณ์',
          code: 'accident',
          icon: require('@/assets/icons/train.svg'),
          today: 0,
          summary: 0
        },
        {
          name: 'อุบัติเหตุ',
          code: 'accident',
          icon: require('@/assets/icons/train_accident.svg'),
          today: 0,
          summary: 0
        },
        {
          name: 'ผู้เสียชีวิต',
          code: 'dead',
          icon: require('@/assets/icons/death.svg'),
          today: 0,
          summary: 0
        },
        {
          name: 'ผู้บาดเจ็บ',
          code: 'injury',
          iconfa: 'user-injured',
          today: 0,
          summary: 0
        }
      ];
    }
  }
};
</script>

<style lang="scss" scoped>
.box {
  height: 100%;
  display: grid;
}

.col {
  padding-top: 0;
  padding-bottom: 0;
}

.col .img {
  padding: 0;
}

.card {
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.3);
  border-radius: 3px;
  margin-top: 15px;
}

.stat {
  background-color: white;
  margin: auto;
}

.number {
  color: #ba4438;
  text-align: center;
}

p {
  text-align: center;
}

.outline-menu {
  // height: 100%;
  height: 56px;
  text-align: center;
}

.menu {
  width: 48px;
  // height: 56px;
  margin: auto;
  top: calc(50% - 24px);
}

.rectangle {
  // width: 180px;
  height: 240px;
  border-radius: 3px;
  border: solid 1px #979797;
}
</style>
